module.exports = __webpack_public_path__ + "static/media/camping-keyvisualbg.0f93ec46.jpg";